import { createSelector } from "reselect";
import _ from "lodash";

const createSelectors = parentReducer => {
    return new (class {
        selectAllEquipments = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["JobPackEquipmentListWidget_reducer"];

            return reducer.equipments;
        };
        selectAllAreas = store => {
            const pageReducer = store[parentReducer];
            const reducer =
                pageReducer["JobPackEquipmentListWidget_reducer"];
            return reducer.areas;
        };
        selectAllDepartments = store => {
            const pageReducer = store[parentReducer];
            const reducer =
                pageReducer["JobPackEquipmentListWidget_reducer"];
            return reducer.departments;
        };
        selectProfile = store => {
            const reducer =
                store["UserProfile_reducer"];
                let userInfo = reducer.user;
            return userInfo.profile;
        };

        selectDept = createSelector (
            [this.selectProfile],
            
            (profile = false) => {
                if(profile)
                {
                    // userDepts = profile.departments
                    return profile.departments
                }
                else return null
            }
        )
        selectAreas = createSelector (
            [this.selectProfile],
            (profile = false) => {
                if(profile)
                {
                    // userAreas = profile.areas
                    return profile.areas
                }
                else return null
            }
        )
        selectEquipmentInfo = createSelector(
            [this.selectAllEquipments, this.selectAllAreas, this.selectAllDepartments, this.selectDept,this.selectAreas],
            (equipments = false, allAr = false, allDept = false,userDepts = false, userAreas = false) => {
                let allAreas = allAr && Object.values(allAr).map((e)=> { return e })
                let allDepartments = allDept && Object.values(allDept).map((e)=> { return e })
                if(userAreas === false)
                {
                    userAreas = allAreas
                }
                if(userDepts === false)
                {
                    userDepts = allDepartments
                }
                let validationArea = []
                let validationDept = []
                if (equipments) {
                    let vecInfo = _.compact(
                        Object.keys(equipments).map(e => {
                            let uid =
                                _.get(equipments[e], "profile.uid") ||
                                "N/A";
                            let category =
                                _.get(
                                    equipments[e],
                                    "profile.category"
                                ) || "N/A";
                            let status =
                                _.get(equipments[e], "profile.status") ||
                                "N/A";
                            let name =
                                _.get(equipments[e], "profile.name") ||
                                "N/A";
                            let areas = 
                                _.get(equipments[e], "profile.areas") || null
                            let departments = 
                                _.get(equipments[e], "profile.departments") || null
                            

                            if(areas === null)
                            {
                                
                                validationArea = _.intersection(allAreas,userAreas)
                            }
                            else{
                                validationArea = _.intersection(areas,userAreas)
                            }
                            if(departments === null)
                            {
                                
                                validationDept = _.intersection(allDepartments,userDepts)
                                
                            }
                            else {
                                validationDept = _.intersection(departments,userDepts)
                            } 
                            
                            if ( validationArea.length !== 0 && validationDept.length !== 0) {
                                    
                                return {
                                    uid,
                                    category,
                                    status,
                                    name
                                };
                                    
                            } else return null;
                            
                        })
                    );
                    return vecInfo;
                } else return false;
            }
        );
    })();
};

export default createSelectors;
